module.exports = __webpack_public_path__ + "static/ddtsi-driver-looking-forward@2x-91a161a1157864c8ae1a6a021982f890.png";